import type { IStudentAnswerRepository } from './interfaces/IStudentAnswerRepository'
import type { StudentAnswer } from '@/types'
import { getDocuments, where } from '@/services/firestore'

export class FirestoreStudentAnswerRepository implements IStudentAnswerRepository {
  async getByClassroomAndStudent(
    classroomId: string,
    studentId: string
  ): Promise<StudentAnswer[]> {
    return getDocuments<StudentAnswer>('student_answers', [
      where('classroom_id', '==', classroomId),
      where('student_id', '==', studentId),
    ])
  }
}
